export default "__VITE_ASSET__81e7d0d0__"